import React, {useState, useEffect} from 'react';
import {DateField, Edit, SimpleForm, TextInput, ImageInput, ImageField, SelectInput, GET_LIST} from 'react-admin'
import {required} from "../../validators";
import EditActions from "../../custom/common/EditActions";
import EditToolbar from "../../custom/common/EditToolbar";
import {dataProvider} from "../../App";

export default (props) => {
  const [siteChoices, setSiteChoices] = useState([]);

  useEffect(()=>{
    dataProvider(
      GET_LIST,
      'sites',
      {}
    ).then(result => setSiteChoices(result.data));
  }, [])

  return (
    <Edit {...props} actions={<EditActions/>}>
    <SimpleForm toolbar={<EditToolbar/>}>
      <TextInput disabled source='id'/>
      <TextInput source='title' validate={required}/>
      <TextInput source='subTitle' validate={required}/>
      <ImageInput source="image">
        <ImageField source="src" title="title"/>
      </ImageInput>
      <TextInput source='link' validate={required}/>
      <DateField source="createdAt" locales='ko' showTime />
    </SimpleForm>
  </Edit>
  )
}
